import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { FC, useState } from 'react';

type SingleInputDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (value: string) => void;
  title?: string;
  text?: string;
  label?: string;
  cancelLabel?: string;
  confirmLabel?: string;
};

const SingleInputDialog: FC<SingleInputDialogProps> = (props) => {
  const { open, onClose, onConfirm, title, text, label, cancelLabel, confirmLabel } = props;
  const [value, setValue] = useState('');

  const handleConfirm = () => {
    onConfirm(value);
    setValue('');
  };

  return (
    <Dialog open={open} onClose={onClose} disableRestoreFocus>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant='body1' color='text.secondary' gutterBottom>
          {text}
        </Typography>
        <TextField
          label={label}
          size='small'
          autoFocus={open}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          InputProps={{ autoComplete: 'off' }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          {cancelLabel ?? 'Cancel'}
        </Button>
        <Button onClick={handleConfirm} color='primary'>
          {confirmLabel ?? 'Ok'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SingleInputDialog;
